import { ContentUnsubscribeModel } from '@/domain/models/content/enrollment/unsubscribe/content-unsubscribe-model'
import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import {
  ContentUnsubscribeCancelRequest,
  ContentUnsubscribeReasonsResponse
} from './content-unsubscribe-service-types'
import { formatContentUnsubscribeReasons } from './content-unsubscribe-service-utils'

const getUnsubscribeUrl = () => makeApiUrl('/v2/user/enrollments')

export const createContentUnsubscribeService = (client = httpServiceClient) => ({
  async fetchCancelReasons(enrollmentId: string): Promise<ContentUnsubscribeModel> {
    const pathUrl = `${getUnsubscribeUrl()}/${enrollmentId}/cancel/reasons`

    const response = await client<ContentUnsubscribeReasonsResponse>({
      method: 'get',
      url: pathUrl
    })

    return formatContentUnsubscribeReasons(response.body.data as ContentUnsubscribeReasonsResponse)
  },

  async cancelEnrollment(
    enrollmentId: string,
    payload: ContentUnsubscribeCancelRequest
  ): Promise<void> {
    const pathUrl = `${getUnsubscribeUrl()}/${enrollmentId}/cancel`

    await client<void>({
      method: 'post',
      url: pathUrl,
      body: payload
    })
  }
})

export const contentUnsubscribeService = createContentUnsubscribeService()
